module.exports = __webpack_public_path__ + "img/upside-down.792238f7.jpg";